import React, { useEffect, useState } from 'react';
import { Container, Typography, Link, Box, useMediaQuery, Stack } from '@mui/material';
import { useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { styled } from '@mui/material/styles';
import { getInviteSrcData } from '../common_modules/components/Common';
import RegisterSubmitButton from '../common_modules/components/RegisterSubmitButton';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import RegisterLayout from '../common_modules/components/RegisterLayout';
import RegisterLayoutWithoutHeader from '../common_modules/components/RegisterLayoutWithoutHeader';
import Divider from '@mui/material/Divider';

// const steps = ['利用契約', 'ECサイト契約', '登録情報入力', '登録内容確認', '申請', '審査', '承認', '登録完了'];
const steps = [
  '利用規約への同意',
  '基本情報入力',
  'ストア情報入力',
  '登録内容の確認',
  '本人確認',
  '審査申請完了'
];

const CustomDivider = styled(Divider)(({ theme }) => ({
  borderColor: '#000000'
}));

const StartRegistration: React.FC = () => {
  const navigate = useNavigate();
  const translate = useTranslate();
  const isSmallScreen = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  // 各フォームの状態を個別に管理
  const [inviteSrc, setInviteSrc] = useState<number | null>(null);
  const [inviteSite, setInviteSite] = useState<string | null>(null);

  // ページ遷移時にセッションストレージのトークンをチェック
  useEffect(() => {
    const registerToken = sessionStorage.getItem('register_token'); // セッションストレージからトークンを取得
    if (!registerToken) {
      // トークンが存在しない場合は token-error ページにリダイレクト
      navigate('/register/client/token-error', { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const data = getInviteSrcData();
    setInviteSrc(data);
    const site = sessionStorage.getItem('inviteSite');
    setInviteSite(site);
  }, []);

  // 下部フォームの「次へ」ボタンが押された時
  const handleNext = () => {
    navigate('/register/client/terms');
  };

  const gap = isSmallScreen ? 3 : 5;

  return (
    <RegisterLayoutWithoutHeader>
      <Container>
        <Stack direction={'column'} gap={gap}>
          <Helmet>
            <title>ECサイト登録</title>
          </Helmet>
          <Typography sx={{ fontSize: { xs: '25px', sm: '34px' } }}>ECサイト登録</Typography>

          {/* {isSmallScreen ? (
            <Typography variant="body1">
              successfeeのECサイト登録を行います。登録に必要な情報をお確かめの上、登録を進めてください。
              <br />
              登録完了までは6ステップあります。
              <br />
              途中「ECサイト登録」は、次の画面へ進んだ段階で、そこまでの手続き内容が保存され、離脱後も次のステップから再開できます。
            </Typography>
          ) : ( */}
          <Typography variant="body1">
            successfeeのECサイト登録を行います。登録に必要な情報をお確かめの上、ステップを進めてください。
            <br />
            ECサイト登録には審査があります。この審査は、申請後、通常3~5営業日で完了します。
          </Typography>
          {/* )} */}

          <Box display="flex" justifyContent="center">
            <Box
              display="flex"
              flexDirection="row"
              alignItems={'center'}
              justifyContent={'space-between'}
              sx={{ maxWidth: isSmallScreen ? '396px' : '684px', width: '100%' }}
            >
              {steps.map((label, index) => (
                <React.Fragment key={label}>
                  {isSmallScreen ? (
                    <Box component="img" src={`/images/img_step_sp${index + 1}.svg`} alt={`step${index + 1}`} />
                  ) : (
                    <Box component="img" src={`/images/img_step_pc${index + 1}.svg`} alt={`step${index + 1}`} />
                  )}
                  {/* 小さい画面では非表示 */}
                  {!isSmallScreen && index < steps.length - 1 && (
                    <Box
                      component="img"
                      src={`/images/step_arrow.svg`}
                      alt={'arrow'}
                      sx={{ width: '24px', height: '24px', padding: '4px 3px' }}
                    />
                  )}
                </React.Fragment>
              ))}
            </Box>
          </Box>

          {/* <CustomDivider /> */}

          {/* <Stack direction={'column'} gap={2}>
            <Typography variant="h5">振込/支払口座</Typography>
            <Typography variant="body1">
              サービス使用料や手数料の支払い、報酬の振込に使用する口座情報をご登録ください。
            </Typography>
          </Stack> */}

          {/* <Stack direction={'column'} gap={2}>
            <Typography variant="h5">身分証明書(個人登録の方)</Typography>
            <Typography variant="body1">
              個人登録の方は、マイナンバーカード、運転免許証などの身分証明書の、表と裏の両面をスキャンまたは撮影して提出してください。
              <br />
              対応形式：JPEG
              <br />
              ファイルサイズ：10MB以下
              <br />
            </Typography>
          </Stack> */}

          <Stack direction={'column'} gap={2}>
            <Stack direction="row" alignItems="center" spacing={'16px'}>
              <Box
                sx={{
                  width: '4px',
                  height: { xs: '24px', sm: '32px' },
                  backgroundColor: '#6E5552'
                }}
              />
              <Typography sx={{ fontSize: { xs: '20px', sm: '24px' } }}>ストアロゴ画像</Typography>
            </Stack>

            <Typography variant="body1">
              PNG形式(背景透過推奨)のストアロゴ画像をご登録ください。
              <br />
              表示時は幅360px、高さ300px以下にリサイズされます。ファイルサイズは512KBまでです。
            </Typography>
          </Stack>

          {/* <Stack direction={'column'} gap={2}>
            <Stack direction="row" alignItems="center" spacing={'16px'}>
              <Box
                sx={{
                  width: '4px',
                  height: { xs: '24px', sm: '32px' },
                  backgroundColor: '#6E5552'
                }}
              />
              <Typography sx={{ fontSize: { xs: '20px', sm: '24px' } }}>バナー画像</Typography>
            </Stack>

            <Typography variant="body1">
              JPEG/PNG形式のバナー画像をご登録ください。
              <br />
              表示時は幅500px、高さ500px以下にリサイズされます。ファイルサイズは512KBまでです。
            </Typography>
          </Stack> */}

          {/* 下部フォーム */}
          <Box display="flex" justifyContent="center">
            <RegisterSubmitButton onClick={handleNext}>登録を開始</RegisterSubmitButton>
          </Box>
        </Stack>
      </Container>
    </RegisterLayoutWithoutHeader>
  );
};

export default StartRegistration;
